var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{attrs:{"id":"help"}},[_c('v-container',{attrs:{"pa-0":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }